export enum RequestedOnMarketplaceEnum {
  DISABLED = 'disabled',
  APPROVED = 'approved',
  PENDING = 'pending',
  REJECTED = 'rejected',
}
